import { observer } from 'mobx-react-lite';
import FontBody1 from '../../../../../../components/fonts/font-body1/font-body1';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import { FormField } from '../../../../../../components/form-field/form-field';
import { Toggle } from '../../../../../../components/inputs/toggle/toggle';
import ControlGroup from '../../../../../../components/layouts/control-group/control-group';
import TranslationInput from '../../../../../../translation/translation-input/translation-input';
import Translation from '../../../../../../translation/translation';
import { IQuestionTypeProps } from '../question-types-props';
import ImageUploadView from '../image-upload-view/image-upload-view';
import './free-text.scss';
import { Tooltip } from '../../../../../../components/tooltip/tooltip';
import IconInfo from '../../../../../../components/icons/icon-info/icon-info';
import Icon from '../../../../../../components/icons/icon/icon';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import { SelectDropdown } from '../../../../../../components/inputs/select-dropdown/select-dropdown';
import { mediaOptionTypeList, MEDIA_OPTION_TYPE, MEDIA_OPTION_TYPE_MAP } from '../../../../constants';
import portalStore from '../../../../../../stores/current-portal-store';
import { FEATURES } from '../../../../../../models/Plan';
import FollowUpQuestionStore from '../../../../stores/follow-up-question-store';

const FuqFreeText: React.FC<IQuestionTypeProps> = observer(({
    // DICLAIMER: before migration to React 18, it was reusing `answerDefaultProps` from question-types-props.ts
    // TODO: discuss during CR
    question = {} as FollowUpQuestionStore,
    disabled = false,
    validationGroup
}) => {
    const selectedMediaOptionType = MEDIA_OPTION_TYPE_MAP[question?.mediaOption as MEDIA_OPTION_TYPE];

    return (
        <>
            {disabled && 
                <div className="answer-title">
                    <Translation Font={FontBody1} variant={FONT_VARIANT.BOLD} translationKey={question?.question as string} />
                    <Translation Font={FontBody1} translationKey={question?.instruction as string} />
                </div>
            }
            
            <ControlGroup>
                <div className="answer-free-text">
                    <div className="text-area-mock">
                        <FontBody1>Enter message</FontBody1>
                        <span>
                            <b>1000</b> / 1000
                        </span>
                    </div>
                </div>

                {!disabled &&
                    <div className="answer-free-text-toggles">
                        <Toggle checked={question?.isImageRequested} onChange={v => question?.setIsImageRequested(v)} label="Request customers to upload images" />
                        <div className="has-tooltip">
                            <Toggle 
                                disabled={question?.isImageRequiredDisabled}
                                checked={question?.isImageRequired} 
                                onChange={v => question?.setIsImageRequired(v)} 
                                label="Customers must upload at least one image"
                            />
                            { !question?.isRequired && 
                                <Tooltip content={
                                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                                        The image request can be mandatory only when the entire question is mandatory
                                    </FontBody2>}>
                                    <Icon Component={IconInfo} />
                                </Tooltip>
                            }
                        </div>
                        
                    </div>
                }
            </ControlGroup>            

            {question?.isImageRequested && 
               <div className={`answer-request-image ${disabled ? 'disabled' : ''}`}>
                    {disabled && 
                        <div className="answer-title">
                            <Translation Font={FontBody1} translationKey={question?.imageInstruction as string} />
                        </div>
                    }

                    {!disabled &&
                        <FormField label="Instructions">
                            <TranslationInput translationKey={question?.imageInstruction} required validationGroup={validationGroup} />
                        </FormField>
                    }

                    <ControlGroup>
                        <ImageUploadView required={ question?.isImageRequired } />

                        {portalStore.isFeatureAllowed(FEATURES.VIDEO_UPLOAD) && 
                            <div className='request-media-options'>
                                <FormField label="Media Option" required>
                                    <SelectDropdown
                                        placeholder="Please select"
                                        value={ selectedMediaOptionType }
                                        options={ mediaOptionTypeList() }
                                        required
                                        validationGroup={ validationGroup }
                                        onChange={ 
                                            v => question?.setMediaOption(v?.value as MEDIA_OPTION_TYPE) 
                                        }
                                    />
                                </FormField>
                            </div>
                        }
                    </ControlGroup>
                </div>
            }
        
        </>
    )
});

export default FuqFreeText;
